import ScrollAnimation from "@i22/scroll-animation";
import Heading from "./component-library6.mjs";
import Paragraph from "./component-library5.mjs";
import LinkButton from "./component-library3.mjs";
import VideoPlayer from "./component-library15.mjs";
import "./component-library205.mjs";
import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {
  name: "VideoHeroContent",
  components: {
    Heading,
    Paragraph,
    LinkButton,
    VideoPlayer
  },
  mixins: [ScrollAnimation],
  props: {
    rowReverse: { type: Boolean, default: false },
    maxContainerWidth: { type: String, default: "1920px" },
    title: {
      type: Object,
      default: () => ({
        label: "Title",
        tag: "h3"
      })
    },
    heroImage: {
      type: Object,
      default: () => ({
        src: "",
        alt: ""
      })
    },
    heroImageAlign: {
      type: String,
      default: "center",
      validator(value) {
        return ["left", "center", "right"].includes(value);
      }
    },
    copy: { type: String, default: "" },
    cta: {
      type: Object,
      default: () => ({
        label: "Cta Label",
        tag: "a",
        to: "/link"
      })
    },
    video: {
      type: Object,
      default: () => ({
        src: "",
        poster: ""
      })
    },
    animationProduct: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "center center",
        vars: { y: 200 }
      })
    },
    animationContent: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "top+=15% center",
        vars: { y: 120 }
      })
    },
    controls: { type: Boolean },
    videoAriaLabel: { type: String, default: "" },
    playButtonAriaLabel: { type: String, default: "Play Video" },
    pauseButtonAriaLabel: { type: String, default: "Pause Video" }
  },
  mounted() {
    this.$nextTick(() => {
      this.createScrollAnimations();
    });
  },
  methods: {
    createScrollAnimations() {
      if (this.animationContent) {
        this.createScrollTrigger({
          trigger: this.$refs.content,
          start: this.animationContent.start,
          end: this.animationContent.end,
          scrub: 1.25,
          animation: this.createTweenFrom(this.$refs.content, this.animationContent.vars)
        });
      }
      if (this.animationProduct) {
        this.createScrollTrigger({
          trigger: this.$refs.heroImage,
          start: this.animationProduct.start,
          end: this.animationProduct.end,
          scrub: 1.5,
          animation: this.createTweenFrom(this.$refs.heroImage, this.animationProduct.vars)
        });
      }
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "video-hero-content", style: `--data-max-container-width: ${_vm.maxContainerWidth}` }, [_c("div", { staticClass: "video-hero-content__row", class: { "video-hero-content__row--reverse": _vm.rowReverse } }, [_c("div", { staticClass: "video-hero-content__video" }, [_vm.video.src ? _c("VideoPlayer", { attrs: { "autoplay": "", "play-button-centered": false, "loop": "", "muted": "", "controls": _vm.controls, "src": _vm.video.src, "poster": _vm.video.poster, "video-aria-label": _vm.videoAriaLabel, "play-button-aria-label": _vm.playButtonAriaLabel, "pause-button-aria-label": _vm.pauseButtonAriaLabel } }) : _c("div", { staticClass: "video-hero-content__img-fallback" }, [_vm._t("image-fallback")], 2), _vm.heroImage ? _c("div", { ref: "heroImage", staticClass: "video-hero-content__hero-image", class: `video-hero-content__hero-image--${_vm.heroImageAlign}` }, [_vm._t("hero")], 2) : _vm._e()], 1), _c("div", { ref: "content", staticClass: "video-hero-content__content" }, [_vm._t("default", function() {
    return [_vm.title ? _c("Heading", { staticClass: "video-hero-content__title", attrs: { "tag": _vm.title.tag, "size": "lg", "text-uppercase": "", "font-weight": "ultra" } }, [_vm._v(" " + _vm._s(_vm.title.label) + " ")]) : _vm._e(), _vm.copy ? _c("Paragraph", { staticClass: "video-hero-content__copy", attrs: { "is-size-big": "" } }, [_vm._v(" " + _vm._s(_vm.copy) + " ")]) : _vm._e(), _vm.cta ? _c("LinkButton", { attrs: { "tag": _vm.cta.tag, "to": _vm.cta.to, "primary": "" } }, [_vm._v(" " + _vm._s(_vm.cta.label) + " ")]) : _vm._e()];
  })], 2)])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "1b2ae84a",
  null,
  null
);
const videoHeroContent = __component__.exports;
export {
  videoHeroContent as default
};
